import React, { useState } from 'react';
import { Box } from '@mui/material';
import TagsHeader from 'components/tags/TagsHeader';
import TagsEmptyState from 'components/tags/TagsEmptyState';
import UpgradeSnackBar from 'components/common/notification/UpgradeSnackBar';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

const TagsContainer = ({ user }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const navigate = useNavigate();
  const { authState } = useAuth();
  
  const handleOpenSnackbar = () => {
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSubscribe = () => {
    setSnackbarOpen(false);
    navigate('/dashboard/subscribe');
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <TagsHeader onCreateTag={handleOpenSnackbar} />
      
      <Box sx={{ 
        flex: 1, 
        display: 'flex', 
        padding: '0px 12px', 
        position: 'relative',
        overflow: 'hidden' 
      }}>
        <TagsEmptyState />
      </Box>

      <UpgradeSnackBar 
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        handleSubscribe={handleSubscribe}
        message="Upgrade to Pro or Pro Plus to access tags"
      />
    </Box>
  );
};

export default TagsContainer;